import 'bootstrap-daterangepicker/daterangepicker.css';
import classnames from 'classnames';
import React, { Component } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, ButtonGroup, Col, Container, Input, Row } from 'reactstrap';
import * as CompanyActions from '../../actions/Companies';
import { filterByNumber, filterPagination, getNumbers } from '../../actions/Numbers';
import * as ProvisioningActions from '../../actions/Provisioning';
import E911AddressModal from '../../components/E911AddressModal';
import QueryLrnModal from '../../components/QueryLrnModal';
import NewNumber from './NewNumber';
import E911 from './E911';
import Routing from './Routing';
import WithUserData from '../../HOC/withUserData';
import './Provisioning.css';
import { orderBy } from 'lodash';
import { getStateCountry } from '../../actions/ProposalsEditor';
import { getTrunkGroupList } from '../../actions/Inteliquent';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

class Provisioning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNumberTab: 'search',
      sameForAll: false,
      filterNumberValue: '',
      selectedNumberId: '',
      numPage: 1,
      sort: {
        name: '',
        order: '',
      },
      states: [],
      orderedNumbers: [],
      provider:
        process.env.REACT_APP_TEMP_NUMBER_CAREER_INTELIQUENT == 'true' ? 'Inteliquent' : 'VoiceTel',
      lrnNumberType: 'standard',
      portingAccessEnabled: false,
    };
    this.token = localStorage.getItem('jwtToken') || null;
  }

  async componentWillMount() {
    if (
      this.props.user.role === 'superAdmin' ||
      this.props.user.role === 'companyGroupAdmin' ||
      this.props.user.role === 'supportEngineer'
    ) {
      this.props.getCompanies(this.token, undefined, 'yes');
      this.props.getGateways(this.token);
      this.props.getTrunkGroupList(this.token);
      this.props.getNumbers(this.token, this.props.paginOptions, null, 'all');
      const res = await this.props.getStateCountry(this.token);
      const portingAccessEnabledPermission = getPermissionForComponent('portingAccessEnabled',this.props.user.permissionsGroup);
      this.setState({ portingAccessEnabled: portingAccessEnabledPermission })
      if (res) {
        this.setState({ states: res });
      }
    }
  }

  toggleTab = e => {
    this.setState({ activeNumberTab: e });
  };

  companySearchFilter = async ({ suggestion }) => {
    const { getNumberCompanyEmails } = this.props;
    this.setState({
      selectedNumber: '',
    });
    if (suggestion !== null) {
      this.setState({ selectedCompany: suggestion._id });
      getNumberCompanyEmails(
        this.token,
        suggestion._id,
        true,
        undefined,
        undefined,
        suggestion.name,
      );
    } else if (
      this.props.user.role === 'superAdmin' ||
      this.props.user.role === 'supportEngineer' ||
      this.props.user.role === 'companyGroupAdmin' ||
      this.props.user.role === 'companyGroupManager'
    ) {
    } else if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
    }
  };

  handleChangePagination = async numPage => {
    const { numbers, getNumbers, filterPagination, filterByNumber, user } = this.props;
    this.setState({ numPage });
    filterPagination({ page: numPage, limit: numbers.allNumbers.limit });
    if (
      user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'supportEngineer'
    ) {
      if (this.state.filterNumberValue !== '') {
        await filterByNumber(this.token, null, this.state.filterNumberValue, {
          page: numPage,
          limit: numbers.allNumbers.limit,
        });
      } else {
        await getNumbers(
          this.token,
          { page: numPage, limit: numbers.allNumbers.limit },
          null,
          'all',
        );
      }
    }
  };

  searchNumber = e => {
    if (e.qty === 0 || e.qty === '') {
      toast.error('Quantity is required');
    } else if (
      (!isNaN(e.m1) || e.m1 === '' || e.m1 === 'x') &&
      (!isNaN(e.m2) || e.m2 === '' || e.m2 === 'x') &&
      (!isNaN(e.m3) || e.m3 === '' || e.m3 === 'x') &&
      (!isNaN(e.m4) || e.m4 === '' || e.m4 === 'x') &&
      (!isNaN(e.m5) || e.m5 === '' || e.m5 === 'x') &&
      (!isNaN(e.m6) || e.m6 === '' || e.m6 === 'x') &&
      (!isNaN(e.m7) || e.m7 === '' || e.m7 === 'x') &&
      (!isNaN(e.m8) || e.m8 === '' || e.m8 === 'x') &&
      (!isNaN(e.m9) || e.m9 === '' || e.m9 === 'x') &&
      (e.m10 === '' || e.m10 === 'x')
    ) {
      this.searchNumberCall(e);
    } else if (
      isNaN(e.m1) ||
      isNaN(e.m2) ||
      isNaN(e.m3) ||
      isNaN(e.m4) ||
      isNaN(e.m5) ||
      isNaN(e.m6) ||
      isNaN(e.m7) ||
      isNaN(e.m8) ||
      isNaN(e.m9) ||
      isNaN(e.m10)
    ) {
      toast.error('Invalid entry in Mask');
    } else {
      this.searchNumberCall(e);
    }
  };

  searchNumberCall = e => {
    const data = {
      quantity: e.qty,
      province: e.state,
      tnMask: e.m1 + e.m2 + e.m3 + e.m4 + e.m5 + e.m6 + e.m7 + e.m8 + e.m9 + e.m10,
    };
    this.props.searchNumber(this.token, data, this.state.provider);
  };

  onToggleChange = () => {
    this.setState({ sameForAll: !this.state.sameForAll });
  };

  numberSearchFilter = async number => {
    const { filterByNumber, pagination, getNumbers } = this.props;
    if (number !== '') {
      const paginOptions = pagination ? pagination.page : null;
      this.setState({ filterNumberValue: number }, async () => {
        await filterByNumber(this.token, null, number, paginOptions);
      });
    } else {
      this.setState({ filterNumberValue: '' });
      await getNumbers(this.token, null, null, 'all');
    }
  };

  openModalReq = e => {
    this.props.showE911AddressModal();
    this.setState({ selectedNumberId: e._id, selectedNumberTitle: e.number }, () => {
      this.props.getAddress(this.token, this.state.selectedNumberId);
    });
  };

  onOrder = async e => {
    const { selectedNumbers, orderNumber, clearSearchedNumbers, resetSelectedNumbers } = this.props;
    const { sameForAll } = this.state;

    if (!e.cid || e.tn === '' || e.route === '') {
      toast.error('All fields are required');
      return;
    }

    let routeInfo;
    try {
      routeInfo = JSON.parse(e.route);
    } catch (error) {
      routeInfo = e.route;
    }

    const createOrderData = (tn) => ({
      cid: e.cid,
      route: routeInfo?.route || routeInfo,
      gateway: routeInfo?.gateway || routeInfo,
      sms: e.sms,
      tn: tn,
      uid: e.uid || '',
      tempDID: e.tempDID,
    });

    const createBody = (tnItem) => ({
      tnOrder: {
        tnList: {
          tnItem: tnItem,
        },
      },
    });

    const token = this.token;

    const orderNumberAndUpdateState = async (data) => {
      const body = createBody(data);
   
      const res = await orderNumber(token, { data: body, cid: e?.cid });
      if (res) {
        this.setState({ orderedNumbers: data });
        clearSearchedNumbers();
        resetSelectedNumbers([]);
      }
    };

    if (sameForAll) {
      const dataPromises = selectedNumbers.map(async tn => createOrderData(tn));
      const dataList = await Promise.all(dataPromises);
      await orderNumberAndUpdateState(dataList);
    } else {
      const data = createOrderData(e.tn);
      await orderNumberAndUpdateState([data]);
    }
  };

  onUpdate = e => {
    this.props.updateAddress(this.token, this.state.selectedNumberId, e);
    this.props.clearAddress();
  };

  selectRoute = (id, body) => {
    this.props.updateNumberRoute(this.token, id, body);
  };

  handleQueryClick = async e => {
    const res = await this.props.assignRouteInfo(this.token, e);
    if (res) {
      this.handleChangePagination(this.state.numPage);
    }
  };

  handleQueryLrn = e => {
    this.setState({ selectedNumberTitle: e.number });
    this.props.showQueryLrnModalFn(true);
    this.props.queryLrn(this.token, e._id);
  };

  handleLrnInfoByNumber = async () => {
    const { tenDigitNumber, lrnNumberType } = this.state;
    const { showQueryLrnModalFn, lrnInfoByNumber } = this.props;

    if (tenDigitNumber !== undefined && tenDigitNumber !== '') {
      const lrnRoute = lrnNumberType === 'standard' ? 'lrnInfoByNumber' : 'LrnInfoByTfnNumber';
      showQueryLrnModalFn(true);
      await lrnInfoByNumber(this.token, tenDigitNumber, lrnRoute);
    }
  };

  handleSortProvisioning = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [
          el =>
            el[sortNameArr[0]] === null ? '' : el[sortNameArr[0]][sortNameArr[1]].toLowerCase(),
        ],
        [sort.order],
      );
    }
    if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    }
    return orderBy(array, [el => el[sort.name]], [sort.order]);
  };

  onRemoveAddress = async () => {
    const { selectedNumberId, selectedNumberTitle } = this.state;
    const { removeNumberAddress } = this.props;
    const withoutPlusOne = selectedNumberTitle.split('+1');
    const body = { dn: withoutPlusOne[1] };
    // await removeNumberAddress(this.token, selectedNumberId, body);
  };
  setProvider = val => {
    this.props.clearSearchedNumbers();
    this.props.resetSelectedNumbers([]);
    this.setState({ provider: val });
  };

  render() {
    const {
      user,
      filterEmails,
      searchedNumbers,
      gateways,
      numbers,
      clearSearchedNumbers,
      resetSelectedNumbers,
    } = this.props;
    const { activeNumberTab, sort } = this.state;

    const activeProvisioningTab = this.props.match.path.split('/')[2];

    const renderList = sort.name.length
      ? numbers.allNumbers?.docs?.length && this.sortColumnByKey(numbers.allNumbers.docs)
      : numbers.allNumbers.docs;

    const columns = [
      {
        dataField: 'telephoneNumber',
        text: 'Number',
      },
    ];

    const selectRow = {
      mode: 'checkbox',
      clickToSelect: true,
      selected: this.props.selectedNumbers,
      onSelectAll: (isSelect, rows) => {
        if (isSelect) {
          rows.forEach(item => {
            this.props.addSelectedNumbers(item.telephoneNumber);
          });
        } else {
          this.props.resetSelectedNumbers([]);
        }
      },
      onSelect: (isSelect, rows) => {
        if (rows) {
          this.props.addSelectedNumbers(isSelect.telephoneNumber);
        } else {
          const array = this.props.selectedNumbers;
          const index = array.indexOf(isSelect.telephoneNumber);
          if (index !== -1) {
            array.splice(index, 1);
            this.props.resetSelectedNumbers(array);
          }
        }
      },
    };

    if (!user || !user._id) return <Redirect to="/login" />;

    return (
      <Container fluid>
        {activeProvisioningTab !== 'new-number' ? (
          <Row className="row flex-row-reverse" style={{ marginBottom: '20px' }}>
            {activeProvisioningTab === 'routing' ? (
              <Col md="5">
                <div style={{ display: 'flex' }}>
                  <Input
                    type="select"
                    onChange={e => this.setState({ lrnNumberType: e?.target?.value })}
                  >
                    <option key="standard" value="standard">
                      Standard Number
                    </option>
                    <option key="toll-free" value="toll-free">
                      Toll-Free Number
                    </option>
                  </Input>
                  <Input
                    type="number"
                    value={this.state.tenDigitNumber}
                    placeholder="10 Digit Number"
                    onChange={e => this.setState({ tenDigitNumber: e.target.value })}
                  />

                  <Button
                    color="secondary"
                    onClick={this.handleLrnInfoByNumber}
                    style={{ marginLeft: '5px', width: '60%' }}
                  >
                    Query LRN
                  </Button>
                </div>
              </Col>
            ) : null}
            <Col md="2">
              <Input
                type="text"
                value={this.state.number}
                placeholder="Search Number"
                onChange={e => this.numberSearchFilter(e.target.value)}
              />
            </Col>
          </Row>
        ) : null}
        <div className="viewContainer">
          <ButtonGroup className="tab-group">
            <Button
              className={classnames({ active: activeProvisioningTab === 'new-number' })}
              onClick={() => {
                this.props.clearSearchedNumbers();
                this.props.resetSelectedNumbers([]);
                this.props.history.push('/provisioning/new-number');
              }}
            >
              New Number
            </Button>
            { this.state.portingAccessEnabled && 
              <Button onClick={() => this.props.history.push('/provisioning/porting')}>
              Porting
            </Button>
            }
            <Button
              className={classnames({ active: activeProvisioningTab === 'e911' })}
              onClick={() => {
                this.props.getNumbers(this.token, null, null, 'all');
                this.props.history.push('/provisioning/e911');
              }}
            >
              E911
            </Button>

            <Button
              className={classnames({
                active: activeProvisioningTab === 'routing',
              })}
              onClick={() => {
                this.props.getNumbers(this.token, null, null, 'all');
                this.props.history.push('/provisioning/routing');
              }}
            >
              Routing
            </Button>
          </ButtonGroup>

          <Row>
            <Col md="12" className="text-left">
              {activeProvisioningTab === 'new-number' && (
                <NewNumber
                  {...{
                    companySearchFilter: this.companySearchFilter,
                    onToggleChange: this.onToggleChange,
                    onOrder: this.onOrder,
                    companies: this.props.companies,
                    selectedNumbers: this.props.selectedNumbers,
                    clearSearchedNumbers,
                    resetSelectedNumbers,
                    state: this.state,
                    toggleTab: this.toggleTab,
                    searchNumber: this.searchNumber,
                    activeNumberTab,
                    selectRow,
                    searchedNumbers,
                    columns,
                    gateways,
                    filterEmails,
                    setProvider: val => this.setProvider(val),
                    provider: this.state.provider,
                  }}
                />
              )}

              {activeProvisioningTab === 'e911' && (
                <E911
                  {...{
                    openModalReq: this.openModalReq,
                    handleSortProvisioning: this.handleSortProvisioning,
                    handleChangePagination: this.handleChangePagination,
                    numbers,
                    renderList,
                    sort,
                  }}
                />
              )}
              {activeProvisioningTab === 'routing' && (
                <Routing
                  {...{
                    handleQueryClick: this.handleQueryClick,
                    handleQueryLrn: this.handleQueryLrn,
                    selectRoute: this.selectRoute,
                    handleSortProvisioning: this.handleSortProvisioning,
                    handleChangePagination: this.handleChangePagination,
                    numbers,
                    renderList,
                    gateways,
                    sort,
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
        {this.props.showModal && (
          <E911AddressModal
            selectedNumberTitle={this.state.selectedNumberTitle}
            onRemoveAddress={this.onRemoveAddress}
            data={this.props.addressModalData?.entry_query}
            onUpdate={this.onUpdate}
            isOpen={this.props.showModal}
            onCancel={() => {
              this.props.hideE911AddressModal();
              this.props.clearAddress();
            }}
          />
        )}

        {this.props.showQueryLrnModal && (
          <QueryLrnModal
            selectedNumberTitle={this.state.selectedNumberTitle}
            data={this.props.queryLrnData}
            onUpdate={this.onUpdate}
            isOpen={this.props.showQueryLrnModal}
            onCancel={this.props.hideQueryLrnModalFn}
          />
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  selectedNumbers: state.UIState.provisioning.selectedNumbers,
  searchedNumbers: state.AppState.provisioning.searchedNumbers,
  gateways: state.AppState.provisioning.gateways,
  e911: state.AppState.provisioning.e911,
  user: state.AppState.user,
  companies: state.AppState.companies,
  filterEmails: state.UIState.provisioning.filterEmails,
  showModal: state.UIState.provisioning.showE911AddressModal,
  showQueryLrnModal: state.UIState.provisioning.showQueryLrnModal,
  numbers: state.AppState.numbers,
  addressModalData: state.AppState.provisioning.address,
  queryLrnData: state.AppState.provisioning.queryLrn,
  trunks: state.AppState.provisioning.trunkGroupList,
});

const mapDispatchToProps = dispatch => ({
  getStateCountry: token => dispatch(getStateCountry(token)),
  showQueryLrnModalFn: () => dispatch(ProvisioningActions.showQueryLrnModalFn()),
  hideQueryLrnModalFn: () => dispatch(ProvisioningActions.hideQueryLrnModalFn()),
  assignRouteInfo: (token, numId) => dispatch(ProvisioningActions.assignRouteInfo(token, numId)),
  queryLrn: (token, numId) => dispatch(ProvisioningActions.queryLrn(token, numId)),
  lrnInfoByNumber: (token, numId, lrnRoute) =>
    dispatch(ProvisioningActions.lrnInfoByNumber(token, numId, lrnRoute)),
  addSelectedNumbers: number => dispatch(ProvisioningActions.selectedNumbers(number)),
  resetSelectedNumbers: number => dispatch(ProvisioningActions.resetSelectedNumbers(number)),
  clearSearchedNumbers: () => dispatch(ProvisioningActions.clearSearchedNumbers()),
  searchNumber: (token, body, provider) =>
    dispatch(ProvisioningActions.searchNumber(token, body, provider)),
  getGateways: token => dispatch(ProvisioningActions.getGateways(token)),
  getAddress: (token, numId) => dispatch(ProvisioningActions.getAddress(token, numId)),
  updateAddress: (token, numId, body) =>
    dispatch(ProvisioningActions.updateAddress(token, numId, body)),
  removeNumberAddress: (token, id, body) =>
    dispatch(ProvisioningActions.removeNumberAddress(token, id, body)),
  updateNumberRoute: (token, numId, body) =>
    dispatch(ProvisioningActions.updateNumberRoute(token, numId, body)),
  orderNumber: (token, number) =>
    dispatch(ProvisioningActions.orderNumber(token, number)),
  showE911AddressModal: () => dispatch(ProvisioningActions.showE911AddressModal()),
  hideE911AddressModal: () => dispatch(ProvisioningActions.hideE911AddressModal()),
  getNumberCompanyEmails: (token, id, uid, type, gflag, name) =>
    dispatch(ProvisioningActions.getNumberCompanyEmails(token, id, uid, type, gflag, name)),
  filterPagination: pagination => dispatch(filterPagination(pagination)),
  getNumbers: (token, pagination, id, type) => dispatch(getNumbers(token, pagination, id, type)),
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(CompanyActions.getCompanies(token, pagination, disablePaginate)),
  filterByNumber: (token, id, number, pagination) =>
    dispatch(filterByNumber(token, id, number, pagination)),
  clearAddress: () => dispatch(ProvisioningActions.clearAddress()),
  getTrunkGroupList: token => dispatch(getTrunkGroupList(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Provisioning));
